import { ApolloError, useQuery } from "@apollo/client";
import { MY_JOB_APPLICANT_PROFILE } from "features/jobs/queries";
import { MyJobApplicantProfileQuery } from "../__generated__/graphql";

export const useJobApplicantProfile = (): {
  loading: boolean;
  error?: ApolloError;
  applicantProfile?: MyJobApplicantProfileQuery["myJobApplicantProfile"];
  refetch: () => void;
} => {
  const { loading, error, data, refetch } = useQuery(MY_JOB_APPLICANT_PROFILE, {
    fetchPolicy: "network-only",
  });

  if (error && error.message.includes("Job applicant not found")) {
    return {
      loading: false,
      refetch,
    };
  }

  return {
    loading,
    error,
    refetch,
    ...(!!data?.myJobApplicantProfile && { applicantProfile: data.myJobApplicantProfile }),
  };
};
